/**
 * RTWO Asset & Token Engine — Token Standard Registry Service
 */

import { RTWO_TOKEN_STANDARDS } from '../domain-models';
import type { RTWOTokenStandard, StandardId } from '../domain-models';
import type { ITokenStandardRegistryService } from '../service-interfaces';
import { BaseASSService, type ASSServiceContext } from './base-ass-service';

export class TokenStandardRegistryService
  extends BaseASSService
  implements ITokenStandardRegistryService
{
  readonly serviceId = 'ass-token-standard-registry-001';
  readonly serviceName = 'Token Standard Registry Service';
  readonly description = '7 RTWO token standards defined — architecture phase, not operational';
  readonly integrations = ['Core Engine', 'Smart Contract Runtime', 'RPC Platform'];
  readonly requiresLedgerConnection = false;
  readonly requiresTokenRuntime = false;

  constructor(context: ASSServiceContext) {
    super(context);
  }

  async initialize(): Promise<void> {
    this.status = 'structure_ready';
  }

  getAllStandards(): RTWOTokenStandard[] {
    return RTWO_TOKEN_STANDARDS;
  }

  getStandard(standardId: StandardId): RTWOTokenStandard | null {
    return RTWO_TOKEN_STANDARDS.find((standard) => standard.standardId === standardId) ?? null;
  }

  getStandardCount(): number {
    return RTWO_TOKEN_STANDARDS.length;
  }
}
